import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import {store}  from './redux/app/store';
import './assets/styles/_global.scss';
import { ApolloClient, ApolloProvider, HttpLink, InMemoryCache, from } from '@apollo/client'
import {setContext} from '@apollo/client/link/context'
import { onError } from "@apollo/client/link/error";
import {config} from './config/config'
import {Amplify} from 'aws-amplify'
import {fetchAuthSession, getCurrentUser} from 'aws-amplify/auth'
import { GlobalProvider } from './MeetContext/MeetContext';
import { MeetingProvider } from 'amazon-chime-sdk-component-library-react';
import { ChimeMeetingProvider } from './Chime/ChimeMeetingContext';
import { logout as authLogout } from './redux/slices/authSlice';

Amplify.configure(config.amplifyConfig);

//get new accessToken
const getNewAccessToken = async () => {
  try {
    const session = await fetchAuthSession({ forceRefresh: true }).catch((error) => {
      console.log("[Log] Token refresh failed 1: ", error);
      store.dispatch(authLogout()); 
      return;
    });

    if (session?.tokens === undefined) {
      console.log("[Log] refresh token Expired", session );
      store.dispatch(authLogout()); 
      return;
    }
    console.log("[Log] session", session);
    return session;
  } catch (error: unknown) {
    console.error("[Log] Token refresh failed 2: ", error);
    store.dispatch(authLogout()); 
    return;
  }
};

//checking that the accessToken is Expired or not`
const setAuthorizationLink = setContext(
  async (request: any, previousContext: any) => {
    let accessToken: any = localStorage.getItem(Object.keys(localStorage).find((key) => key.includes('accessToken')) as string) || '';
    let saId:any = localStorage.getItem('saId')
    let virutalProgramId:string | null = localStorage.getItem('virtualProgramId')
    if (accessToken) {
      const jwtPayload = JSON.parse(window.atob(accessToken.split('.')[1]));
      const isExpired = Date.now() >= jwtPayload.exp * 1000;
      if (isExpired) {
        await getNewAccessToken()
        .then((data)=>{
          const tokens = data?.tokens;
          const extractedData = String(tokens?.accessToken?.toString());
          accessToken = extractedData;
        })
        .catch((err) => {
          console.log("err", err);
        })
      }
    }
    return _buildAuthHeader(accessToken,saId, virutalProgramId);
  }
);


const _buildAuthHeader = (token: string,saId:string, virutalProgramId: string |null ) => {
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
      saId:saId?saId:'',
      vprogramid : virutalProgramId ? virutalProgramId : ''
    },
  };
};

const getCurrentUserDetail = async () => {
  return await getCurrentUser();
}

const logout = onError(({graphQLErrors}:any) => {
  // try{
    if(graphQLErrors)
    getCurrentUserDetail()
    .then(() => console.log("logged in"))
            .catch((err) =>  {
              // if(err.message === 'User needs to be authenticated to call this API.'){
              //   globalLogout.GlobalLogout();
              // }
              console.log("errmessage",err.message);
            })
  // }catch(err:any){
  //   console.log("error in logout---",err,err.message)
  // }
});

const httpLink = new HttpLink({ uri: config.backend_url });
const client = new ApolloClient({
  link: from([setAuthorizationLink, httpLink, logout]),
  cache: new InMemoryCache({
    addTypename: false
  }),
  defaultOptions: {
    query: {
      fetchPolicy: "network-only",
      errorPolicy: "all",
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ApolloProvider client={client}>
    <GlobalProvider>
      <MeetingProvider>
        <ChimeMeetingProvider>
          <BrowserRouter>
            <Provider store={store}>
              <App />
            </Provider>
          </BrowserRouter>
        </ChimeMeetingProvider>
      </MeetingProvider>
    </GlobalProvider>
  </ApolloProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
